function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.65039 5.40255C1.09811 5.40255 0.650391 4.95484 0.650391 4.40255C0.650391 4.04516 0.837876 3.73156 1.11986 3.55473L3.80748 0.867113C4.198 0.476588 4.83117 0.476588 5.22169 0.867112C5.61222 1.25764 5.61222 1.8908 5.22169 2.28133L4.10046 3.40255L11.6504 3.40255C12.2027 3.40255 12.6504 3.85027 12.6504 4.40255C12.6504 4.95484 12.2027 5.40255 11.6504 5.40255L1.69984 5.40255C1.69072 5.40268 1.6816 5.40268 1.67247 5.40255H1.65039Z",
  fill: "#252733"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6653 7.37076C16.2176 7.37076 16.6653 7.81847 16.6653 8.37076C16.6653 8.72815 16.4778 9.04175 16.1958 9.21858L13.5082 11.9062C13.1177 12.2967 12.4845 12.2967 12.094 11.9062C11.7035 11.5157 11.7035 10.8825 12.094 10.492L13.2152 9.37076H5.66528C5.113 9.37076 4.66528 8.92304 4.66528 8.37076C4.66528 7.81847 5.113 7.37076 5.66528 7.37076L15.6158 7.37076C15.625 7.37063 15.6341 7.37063 15.6432 7.37076H15.6653Z",
  fill: "#252733"
});

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.a6b7262a.svg";
export { ForwardRef as ReactComponent };